<template>
  <div class="client-center">
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button type="primary" icon="plus" @click="showModal">
          新增规则
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="是否删除?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>
    <a-modal
      :title="Title"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="modalForm" ref="modalForm">
        <a-form-item label="预警信息类型">
          <a-select v-decorator="$decorator('type', '请选择预警信息类型')">
            <a-select-option v-for="item in typeList" :key="item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="业务类型">
          <a-select
            v-decorator="$decorator('businessId', '请选择业务类型')"
            @change="value => handleBusinessChange(value)"
            @focus="handleFocus"
          >
            <a-select-option
              v-for="item in businessList"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="业务模式">
          <a-select
            v-decorator="$decorator('modelId', '请选择业务模式')"
            @focus="handleModelFocus"
          >
            <a-select-option
              v-for="item in modelOptionList"
              :key="item.id"
              :disabled="item.disabled"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import {
  getPage,
  getBusinessList,
  getSearchBusinessList,
  getSearchRegionList,
  getRegionList,
  add,
  remove,
  getFreezeBgList,
  getFreezeModelList,
} from './api'
const CREDIT_MODEL_TYPE = 3
const typeList = [
  {
    value: 1,
    label: '限额超担保',
  },
  {
    value: 2,
    label: '限额超保险',
  },
]
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
  },
  computed: {},
  data() {
    return {
      tableLoading: false,
      visible: false,
      scroll: { x: 1600 }, //滚动设置
      formLayout: 'inline',
      typeList,
      Title: '新增',
      CREDIT_MODEL_TYPE,
      modalForm: this.$form.createForm(this),
      tableData: [],
      businessList: [],
      modelOptionList: [],
      modelList: [],
      syList: [], // 冻结BG
      moList: [], //业务模式冻结
    }
  },
  mounted() {
    this._getTableData()
    this._getSearchBusinessList()
    this._getBusinessList()
    this._getFreezeBgList()
  },

  methods: {
    handleFocus() {
      if (this.businessList) {
        this.businessList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.businessList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },
    //业务模式禁用
    handleModelFocus() {
      if (this.modelOptionList) {
        this.modelOptionList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.moList) {
        this.modelOptionList.forEach(item => {
          this.moList.forEach(myitem => {
            if (item.id === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //刷新组件
      }
    },

    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    async handlModelChange(pid) {
      const type = 3
      const { data } = await getRegionList({ pid, type })
      this.modelOptionList = data
      this._getFreezeModelList()
    },
    async handleBusinessChange(pid) {
      const type = 3
      const { data } = await getRegionList({ pid, type })
      this.modelOptionList = data
      this._getFreezeModelList()
      this.modalForm.setFieldsValue({ modelId: '' })
    },

    _getFreezeModelList() {
      getFreezeModelList().then(({ data }) => {
        this.moList = data
      })
    },

    handleOk() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }
          try {
            const { message } = await add({
              ...values,
              id: this.id,
            })
            this.visible = false
            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 获取业务模式列表
    async _getSearchModelList(pid) {
      try {
        const { data } = await getSearchRegionList(pid)
        this.modelList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.searchSchema[2].selectList = this.modelList
      } catch (error) {
        console.log(error)
      }
    },
    handleEdit({ type, modelId, businessId, id }) {
      this.visible = true
      this.Title = '编辑'
      this.handlModelChange(businessId)
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          type,
          modelId,
          businessId,
        })
        this.id = id
      }, id)
    },
    handleModelChange(option) {
      if (option === undefined) {
        this.searchSchema[2].selectList = []
        return
      }
      this._getSearchModelList(option)
    },

    //获取table数据
    async _getTableData() {
      try {
        this.tableLoading = true
        const { current, pageSize } = this.pageData
        const query = {
          ...this.searchData,
          size: pageSize,
          current,
        }
        delete query.pageSize
        const {
          data: { total, records },
        } = await getPage(query)
        this.tableData = records
        this.pageData.total = total
        this.tableLoading = false
      } catch (err) {
        console.log(err)
      }
    },
    async _getSearchBusinessList() {
      try {
        const { data } = await getSearchBusinessList()
        this.searchSchema[1].selectList = data.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async _getBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.businessList = data
      } catch (err) {
        console.log(err)
      }
    },

    async _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },

    showModal() {
      this.Title = '新增'
      this.modalForm.resetFields()
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.modalForm.resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
#components-a-tooltip-demo-placement .ant-btn {
  width: 70px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
